export default {
        logrocket: require('./components/logrocket/dist.index.js').default,
application: require('./components/application/dist.index.js').default,
layout: require('./components/layout/dist.index.js').default,
sidebarCollapsed: require('./components/sidebarCollapsed/dist.index.js').default,
flex: require('./components/flex/dist.index.js').default,
text: require('./components/text/dist.index.js').default,
button: require('./components/button/dist.index.js').default,
image: require('./components/image/dist.index.js').default,
searchBoxV2: require('./components/searchBoxV2/dist.index.js').default,
dropdown: require('./components/dropdown/dist.index.js').default,
avatar: require('./components/avatar/dist.index.js').default,
form: require('./components/form/dist.index.js').default,
formList: require('./components/formList/dist.index.js').default,
card: require('./components/card/dist.index.js').default,
modal: require('./components/modal/dist.index.js').default,
input: require('./components/input/dist.index.js').default,
select: require('./components/select/dist.index.js').default,
textarea: require('./components/textarea/dist.index.js').default,
divider: require('./components/divider/dist.index.js').default,
cardArrows: require('./components/cardArrows/dist.index.js').default,
dragDropProvider: require('./components/dragDropProvider/dist.index.js').default,
tag: require('./components/tag/dist.index.js').default,
checkbox: require('./components/checkbox/dist.index.js').default,
sliderV2: require('./components/sliderV2/dist.index.js').default,
spin: require('./components/spin/dist.index.js').default,
checkboxGroup: require('./components/checkboxGroup/dist.index.js').default,
link: require('./components/link/dist.index.js').default
      }